import StatusPage from './StatusPage.jsx';

/** 500 — unexpected failure. Also the render target of the app error boundary. */
export default function ServerError500({ onRetry }) {
  return (
    <StatusPage
      code="500"
      title="Something went wrong on our side"
      message="An unexpected error stopped this page from loading. Try again in a moment — if it keeps happening, report it to a platform administrator."
      icon="fa fa-triangle-exclamation"
      tone="danger"
      actions={
        <button
          type="button"
          className="btn btn-primary"
          onClick={onRetry ?? (() => window.location.reload())}
        >
          <i className="fa fa-rotate-right me-2" aria-hidden="true" />
          Try again
        </button>
      }
    />
  );
}
